import { useEffect } from "react";
import { usePatchPropertyArtMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyArtMutation";
import type { ClientPropertyArtDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getArtFormSchema } from "web_myplann/Portfolio/Forms/ArtForm/artFormSchema";
import { mapPropertyToArtForm } from "web_myplann/Portfolio/Forms/ArtForm/mapPropertyToArtForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditArtFormArgs = {
	propertyId: number;
	property: ClientPropertyArtDetailResponseDTO;
	detailRoute: string;
};

export const useEditArtForm = ({
	propertyId,
	property,
	detailRoute,
}: UseEditArtFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPropertyArtMutation(propertyId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getArtFormSchema(t),
		defaultValues: mapPropertyToArtForm(property),
		mutate,
		successToast: t(Resources.Portfolio.EditProperty.savedToast, {
			type: t(Resources.Portfolio.AddItem.Items.art),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
